<template>
  <a-select
    :value="!loading ? value : null"
    v-bind="$attrs"
    :options="options"
    :loading="loading"
    class="w-full"
    @popup-scroll="handlePopupScroll"
  >
    <template #suffixIcon>
      <a-spin v-if="loading" :indicator="indicator" />
      <down-outlined v-else :width="15" :height="13" color="#94989A" />
    </template>
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
    <slot name="option" />
  </a-select>
</template>
<script lang="ts">
export default {
  name: 'CSelect',
}
</script>
<script lang="ts" setup>
import { h } from 'vue'
import { LoadingOutlined } from '@ant-design/icons-vue'
import { DownOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  value: {
    type: [String, Number, Array, null],
    default: '',
  },
  options: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  onScroll: {
    type: Function,
    required: false,
    default: () => false,
  },
})

const handlePopupScroll = (e: Event) => {
  const target = e.target as HTMLElement
  if (target.scrollTop + target.offsetHeight >= target.scrollHeight) {
    if (props.onScroll) {
      props.onScroll()
    }
  }
}

const indicator = computed(() => {
  return h(LoadingOutlined, {
    style: {
      fontSize: '14px',
    },
    spin: true,
  })
})
</script>
